import * as cssVariable from 'cssVariables';
import { breakpoints, mediaQuery } from 'components/theme/breakpoints';

export default {
  auth: {
    display: 'flex',
    marginLeft: 15,
  },

  button: {
    width: 140,
    marginLeft: 15,
  },

  profileButton: {
    border: 'none',
    background: 'transparent',
    color: cssVariable.blue500,
    fontWeight: cssVariable.fontWeights.bold,
    textTransform: 'uppercase',
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  placeholder: {
    width: 36,
    height: 36,
    borderRadius: '50%',
    margin: '0 10px',
    backgroundColor: cssVariable.blue500,
    [mediaQuery.maxWidth(breakpoints.md)]: {
      margin: 0,
    },
  },
  profileThumb: {
    display: 'inline-block',
    width: 28,
    height: 28,
    margin: '0 10px',
    backgroundSize: 'cover',
    borderRadius: '50%',
    [mediaQuery.maxWidth(breakpoints.md)]: {
      margin: 0,
    },
  },
  profileName: {
    display: 'block',
    [mediaQuery.maxWidth(breakpoints.md)]: {
      display: 'none',
    },
  },

  authButton: {
    textTransform: 'capitalize',
    marginRight: 15,
  },

  loginButton: {
    backgroundColor: 'transparent',
  },
};
